module.exports = __webpack_public_path__ + "static/media/hamburger-menu.1139f8e8.svg";